<template>
    <div class="News">
        <div class="news-header-container">
            <div class="news-title-left-info">
                <p class="news-title-text">新闻动态</p>
                <p class="news-title-sub-text">NEWS TRENDS</p>
            </div>
            <div class="news-header-menu-container">
                <el-menu
                    class="news-header-menu"
                    mode="horizontal"
                    default-active="news-trends"
                    @select="doChangeNewsType"
                >
                    <el-menu-item index="news-trends">新闻动态</el-menu-item>
                    <el-menu-item index="corporate-news">企业新闻</el-menu-item>
                    <el-menu-item index="other-news">其他新闻</el-menu-item>
                </el-menu>
            </div>
        </div>
        <div class="news-main-container">
            <el-row :gutter="26">
                <template v-for="item in newsList">
                    <el-col :key="item.id" :span="6">
                        <div class="one-news-info-container">
                            <div class="news-date-container">
                                <span class="date-text">{{
                                    getDateStr(item)
                                }}</span>
                                <span class="year-text">{{
                                    getYearStr(item)
                                }}</span>
                            </div>
                            <div class="one-news-img-container">
                                <img :src="item.imgUrl" alt="" />
                            </div>
                            <p class="one-new-title-text">
                                {{ item.title }}
                            </p>
                            <p class="one-new-content-text">
                                {{ item.description }}
                            </p>
                            <div class="show-detail-btn-container">
                                <router-link :to="`/news/detail/${item.id}`">
                                    <el-link
                                        class="show-detail-btn"
                                        :underline="false"
                                    >
                                        <span>查看详情</span>
                                        <i class="el-icon-right"></i>
                                    </el-link>
                                </router-link>
                            </div>
                        </div>
                    </el-col>
                </template>
                <!-- <el-col :span="6">
                    <div class="one-news-info-container">
                        <div class="news-date-container">
                            <span class="date-text">06/27</span>
                            <span class="year-text">2021</span>
                        </div>
                        <div class="one-news-img-container">
                            <img
                                src="../../assets/images/news-small-bg1.png"
                                alt=""
                            />
                        </div>
                        <p class="one-new-title-text">
                            壮丽山河秀中华，欢颂祖国万年春；神州大地齐欢腾...
                        </p>
                        <p class="one-new-content-text">
                            壮丽山河秀中华，欢颂祖国万年春；神州大地齐欢腾...
                        </p>
                        <div class="show-detail-btn-container">
                            <el-link class="show-detail-btn" :underline="false">
                                <span>查看详情</span>
                                <i class="el-icon-right"></i>
                            </el-link>
                        </div>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="one-news-info-container">
                        <div class="news-date-container">
                            <span class="date-text">06/27</span>
                            <span class="year-text">2021</span>
                        </div>
                        <div class="one-news-img-container">
                            <img
                                src="../../assets/images/news-small-bg2.png"
                                alt=""
                            />
                        </div>
                        <p class="one-new-title-text">
                            壮丽山河秀中华，欢颂祖国万年春；神州大地齐欢腾...
                        </p>
                        <p class="one-new-content-text">
                            壮丽山河秀中华，欢颂祖国万年春；神州大地齐欢腾...
                        </p>
                        <div class="show-detail-btn-container">
                            <el-link class="show-detail-btn" :underline="false">
                                <span>查看详情</span>
                                <i class="el-icon-right"></i>
                            </el-link>
                        </div>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="one-news-info-container">
                        <div class="news-date-container">
                            <span class="date-text">06/27</span>
                            <span class="year-text">2021</span>
                        </div>
                        <div class="one-news-img-container">
                            <img
                                src="../../assets/images/news-small-bg3.png"
                                alt=""
                            />
                        </div>
                        <p class="one-new-title-text">
                            壮丽山河秀中华，欢颂祖国万年春；神州大地齐欢腾...
                        </p>
                        <p class="one-new-content-text">
                            壮丽山河秀中华，欢颂祖国万年春；神州大地齐欢腾...
                        </p>
                        <div class="show-detail-btn-container">
                            <el-link class="show-detail-btn" :underline="false">
                                <span>查看详情</span>
                                <i class="el-icon-right"></i>
                            </el-link>
                        </div>
                    </div>
                </el-col> -->
            </el-row>
        </div>
    </div>
</template>

<script>
import { GETNEWSLIST } from "../../utils/uriList";

export default {
    mounted() {
        this.getNewsList();
    },
    data() {
        return {
            newsList: [],
            menuActive: "news-trends",
        };
    },
    methods: {
        async getNewsList() {
            const response = await this.$http.get(GETNEWSLIST, {
                params: {
                    pageSize: 4,
                    pageNum: 1,
                    type: this.formatNewsTypeParams(),
                    approvalStatus:0,
                },
            });
            if (response.data.code === 0) {
                this.newsList = response.data.data.content;
            }
        },
        getDateStr(item) {
            const time = item.time;
            const splitList = `${time}`.split("-");
            return `${splitList[1]}/${splitList[2]}`;
        },
        getYearStr(item) {
            const time = item.time;
            const splitList = `${time}`.split("-");
            return `${splitList[0]}`;
        },
        doChangeNewsType(index) {
            this.menuActive = index;
            this.getNewsList();
        },
        formatNewsTypeParams() {
            let type;
            switch (this.menuActive) {
                case "news-trends":
                    type = 0;
                    break;
                case "corporate-news":
                    type = 1;
                    break;
                case "other-news":
                    type = 2;
                    break;
                default:
                    break;
            }
            return type;
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/components/Home/News.scss";
</style>
